import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client';
import type { DashboardData } from '@aigftpwatch/shared';

export function useDashboard() {
  return useQuery({
    queryKey: ['dashboard'],
    queryFn: () => api.get<DashboardData>('/dashboard').then((r) => r.data),
    refetchInterval: 60_000,
  });
}
